import styled from 'styled-components';
import { Flex } from '../../../../GlobalComponents/Flex';

const TitleContainer = styled(Flex)`
	flex-direction: column;
	column-gap: 12px;
	align-items: flex-start;
	height: 120%;

	@media (max-width: 340px) {
		flex-direction: column;

		align-items: unset;
		row-gap: 4px;
	}
`;

const OrderDate = styled.h1`
	color: #575757;
	font-size: 24px;
	font-weight: 700;
	margin-bottom: 0;
	line-height: 120%;
`;

const OrderIcons = styled.div`
	margin-top: 12px;
	margin-bottom: 12px;
	height: 48px;
	margin-right: auto;
	margin-left: 0;
`;

const TotalCost = styled.h1`
	color: #f47920;
	font-size: 24px;
	margin-bottom: 12px;
	font-weight: 700;
	margin-bottom: 4px;
`;

const PlacedText = styled.h2`
	color: #575757;
	font-size: 20px;
`;

const Address1 = styled.p`
	color: #757575;
	font-weight: 500;
	font-size: 16px;
	line-height: 100%;
	margin-bottom: 4px;
`;

const CityStateZip = styled.p`
	color: #757575;
	font-weight: 500;
	font-size: 16px;
	line-height: 100%;
	margin-bottom: 0;
`;

const OrderHistoryTitle = styled.h1`
	color: #f47920;
	border-bottom: solid 2px #f47920;
	padding-bottom: 24px;
	font-weight: 700;
	width: 150%;
`;

const Container = styled.div`
	margin-bottom: 24px;
	padding: 0 0 24px 0;
	display: flex;
	flex-direction: column;
	row-gap: 24px;
	border-bottom: solid 2px;
	border-color: rgba(117, 117, 117, 0.25);
	width: 100%;
`;

const HistoryIcons = styled.div`
	margin-right: 12px;
`;

const OrderStatus = styled.div`
	color: #f47920;
	font-weight: 500;
	font-size: 16px;
	white-space: nowrap;
	margin-right: 4px;
`;

export {
	TitleContainer,
	Container,
	OrderDate,
	OrderIcons,
	TotalCost,
	PlacedText,
	Address1,
	CityStateZip,
	OrderHistoryTitle,
	HistoryIcons,
	OrderStatus
};
